export default __webpack_public_path__ + "static/media/chatgpt_example_en.d29a7612.png";